import ozDevelopmentType from './oz-development-type.vue'

export default ozDevelopmentType
